import { UserManager, WebStorageStateStore, User } from "oidc-client";
import { config } from "@/core/config";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import axios from 'axios';
import qs from "qs";


export default class AuthService {
  private userManager: UserManager;

  constructor() {
    const settings: any = {
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      monitorSession: false,
      automaticSilentRenew: true,
      filterProtocolClaims: true,
      accessTokenExpiringNotificationTime: 4,
      loadUserInfo: true,
      client_id: config.ssoClient.client_id,
      authority: config.ssoClient.authority,
      client_secret: "DoNotHackThisKey@joymeet",
      redirect_uri: window.location.origin + "/callback",
      post_logout_redirect_uri: window.location.origin + "/home",
      silent_redirect_uri: window.location.origin + "/silent-renew",
      scope: "openid profile roles joymeetwebapi.scope offline_access",
      response_type: "code",
    };

    this.userManager = new UserManager(settings);
  }

  public getUser(): Promise<User | null> {
    return this.userManager.getUser();
  }

  public login(): Promise<void> {
    return this.userManager.signinRedirect();
  }

  public logout(): Promise<void> {
    return this.userManager.signoutRedirect();
  }

  public async getAccessToken(): Promise<string | undefined> {
    return this.userManager.getUser().then(async (data: any) => {
      if (data.expired == true) {
        await this._performAccessTokenRenewalViaRefreshToken();
      }
      return data.access_token;
    });
  }


  public signinSilentCallback(): Promise<User | undefined> {
    return this.userManager.signinSilentCallback();
  }

  public signinRedirectCallback(): Promise<User | undefined> {
    return this.userManager.signinRedirectCallback("");
  }

  public signinSilent(): Promise<User | undefined> {
    return this.userManager.signinSilent();
  }

  /*
   * It is not recommended to use a refresh token in the browser, even when stored only in memory, as in this sample
   * The browser cannot store a long lived token securely and malicious code could potentially access it
   * Cognito provides no option to disable refresh tokens for SPAs
   */
  private async _performAccessTokenRenewalViaRefreshToken(): Promise<any> {
    try {
      // The library will use the refresh token grant to get a new access token
      await this.userManager.signinSilent(); // Try to refresh an access token
    } catch (e: any) {
      await this.userManager.removeUser();
    }
  }


  public async getApiAccessToken() {
    const data = {
      client_id: "joymeetnetqa",
      client_secret: "DoNotHackThisKey@joymeetnetqa",
      grant_type: "client_credentials"
    };
    await axios.post(`${config.ssoClient.authority}connect/token`, qs.stringify(data),
      {
        headers: { 'content-type': 'application/x-www-form-urlencoded' }
      }).then(async (data: any) => {
        //console.log("getApiAccessToken", data)
        //console.log("data.access_token", data.data.access_token)
        localStorage.setItem('token', data.data.access_token);
        return data.data.access_token;
      });;
  }
}
